// Utility function to convert relative URLs to absolute URLs
export const getAbsoluteUrl = (relativeUrl) => {
  if (!relativeUrl) return null;
  
  // If it's already an absolute URL (http:// or https://), return as is
  if (relativeUrl.startsWith('http://') || relativeUrl.startsWith('https://')) {
    return relativeUrl;
  }
  
  // If it starts with /api/, it's already a full API path - just add origin
  if (relativeUrl.startsWith('/api/')) {
    return `${window.location.origin}${relativeUrl}`;
  }
  
  // If it starts with /, prepend the current origin
  if (relativeUrl.startsWith('/')) {
    return `${window.location.origin}${relativeUrl}`;
  }
  
  // Otherwise, treat it as relative to current origin
  return `${window.location.origin}/${relativeUrl}`;
};

// Utility function to get backend API URL
export const getBackendUrl = () => {
  const backendUrl = "/api";
  if (backendUrl) {
    return backendUrl;
  }
  // Fallback to relative URL (works with nginx proxy)
  return '';
};

// Utility function to get full API URL
export const getApiUrl = (endpoint) => {
  const backendUrl = getBackendUrl();
  return `${backendUrl}/api${endpoint}`;
};